module.exports = __webpack_public_path__ + "static/how-to-pay-1-d3a001653e508730cc5178d240cb2cbd.png";